<template>
  <div class="activity-container">
    <div class="activity-inner-container">
      <div class="title-container">
        <h2>{{ this.activity && this.activity.name }}</h2>
        <a class="share-btn" @click="share">分享</a>
      </div>
      <img class="cover" :src="`${this.activity.coverPicUrl}`" />
      <div class="item-container">
        <img class="item-icon" src="~@/assets/svg/time.svg" />
        <div class="item-right">
          <h3 class="item-title">报名时间</h3>
          <div>
            <span class="item-content">{{
              this.activity && this.activity.applyStartTime
            }}</span>
            <span class="item-content"> 至 </span>
            <span class="item-content">{{
              this.activity && this.activity.applyEndTime
            }}</span>
          </div>

          <h3 class="item-title">活动时间</h3>
          <div>
            <span class="item-content">{{
              this.activity && this.activity.activityStartTime
            }}</span>
            <span class="item-content"> 至 </span>
            <span class="item-content">{{
              this.activity && this.activity.activityEndTime
            }}</span>
          </div>
        </div>
      </div>

      <div class="item-container">
        <img class="item-icon" src="~@/assets/svg/location.svg" />
        <div class="item-right">
          <h3 class="item-title">活动地点</h3>
          <p class="item-content">
            {{ this.activity && this.activity.address }}
          </p>
        </div>
      </div>

      <!-- <h3 class="item-title">目标人数</h3>
      <p class="item-content">最少20人、最多30人</p> -->

      <!-- <h3 class="item-title">已报名</h3>
      <p class="item-content">23人（男生12人，女生11人）</p> -->

      <!-- <h3 class="item-title">活动发起方</h3>
      <p class="item-content">Luca</p> -->

      <div class="item-container">
        <img class="item-icon" src="~@/assets/svg/money.svg" />
        <div class="item-right">
          <h3 class="item-title">活动费用</h3>
          <p class="item-content">
            {{ this.activity && this.activity.price / 100 }} 元/人
          </p>
        </div>
      </div>
      <div class="item-container">
        <img class="item-icon" src="~@/assets/svg/detail.svg" />
        <div class="item-right">
          <h3 class="item-title">活动详情</h3>
          <p
            class="item-content"
            v-html="this.activity && this.activity.description"
          ></p>
        </div>
      </div>
      <div class="mid-container">
        <p>我的部落ID：{{ mid }}</p>
      </div>
    </div>

    <!-- 活动结束状态 -->
    <template v-if="this.activity && this.activity.activityStatus === 2">
      <a class="apply-cancel-btn">{{ this.activity.activityStatusTips }}</a>
    </template>

    <template v-if="this.activity && this.activity.activityStatus === 2">
      <a class="apply-cancel-btn">{{ this.activity.activityStatusTips }}</a>
    </template>

    <template v-else-if="this.memberStatus === 1">
      <a class="apply-btn" @click="toRegister">立即报名</a>
    </template>

    <template v-else-if="this.memberStatus === 2">
      <a class="apply-btn" @click="toInfo">立即报名</a>
    </template>

    <template v-else>
      <!-- 未报名状态 -->
      <template v-if="this.activity && this.activity.applyStatus === 0">
        <a class="apply-btn" @click="applyActivity">立即报名</a>
      </template>

      <!-- 报名成功状态 -->
      <template v-if="this.activity && this.activity.applyStatus === 1">
        <a class="apply-cancel-btn" @click="cancelActivity">
          <span class="apply-success-text">我已报名成功</span>
          <span class="apply-cancel-text">取消报名</span>
        </a>
      </template>

      <!-- 取消报名状态 -->
      <template v-if="this.activity && this.activity.applyStatus === 2">
        <a class="reapply-btn" @click="applyActivity">重新报名</a>
      </template>
    </template>

    <van-popup v-model="isDisplay" @close="this.close">
      <div class="popup-container">
        <img width="150px" src="~@/assets/img/qrcode.jpg" />
        <p>扫码联系管理员</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import wxApi from "@/utils/wxAuth";
import {sleep} from "@/utils/tools";

export default {
  name: "activityInfo",
  data() {
    return {
      activity: {},
      item: {},
      isDisplay: false,
      memberStatus: 0,
      mid: ""
    };
  },
  methods: {
    share(e) {
      e.stopPropagation();
      this.$toast("点击右上角分享给好友或朋友圈");
    },
    async toRegister() {
      this.$toast("完成用户注册后即可报名");
      await sleep(2000);
      window.location.href = "/account.html";
    },
    async toInfo() {
      this.$toast("完成基础资料填写后可报名");
      await sleep(2000);
      window.location.href = "/account.html";
    },
    close() {
      this.isDisplay = false;
    },
    async cancelActivity() {
      this.isDisplay = true;
    },
    async applyActivity() {
      if (this.activity) {
        const res = await this.$helloHttp(
          `/wxpay/preOrder/${this.activity.itemId}/JSAPI`,
          {},
          "get",
          {
            Authorization: `Bearer ${window.localStorage.getItem("token")}`
          }
        );
        if (!res.success) {
          return;
        }
        this.item = res.data;
        if (typeof window.WeixinJSBridge === "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              this.onBridgeReady,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
            document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
          }
        } else {
          this.onBridgeReady();
        }
      }
    },
    onBridgeReady() {
      const {
        appId,
        timeStamp,
        nonceStr,
        paySign,
        signType,
        prepayId
      } = this.item;
      if (typeof window !== "undefined") {
        window.WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          {
            appId, // 公众号名称，由商户传入
            timeStamp, // 时间戳，自1970年以来的秒数
            nonceStr, // 随机串
            package: `prepay_id=${prepayId}`,
            signType, // 微信签名方式：
            paySign // 微信签名
          },
          async res => {
            if (res.err_msg === "get_brand_wcpay_request:ok") {
              // 使用以上方式判断前端返回,微信团队郑重提示：
              // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              this.$toast("支付成功！您已经报名成功！");
              window.location.reload();
            }
          }
        );
      }
    },
    async applyAuth() {
      this.$root.openLoading();

      const res = await this.$helloHttp(`/activitys/apply`, {
        code: this.$route.query.code
      });
      if (res.code === 20004) {
        this.memberStatus = 1;
      } else if (res.code === 30012) {
        this.memberStatus = 2;
      } else if (res.code === 0) {
        this.memberStatus = 0;
        window.localStorage.setItem("token", res.data.token);
        window.localStorage.setItem("mid", res.data.mid);

        this.mid = window.localStorage.getItem("mid");
      }
      this.$root.closeLoading();

      await this.getActivity();
    },
    async getActivity() {
      this.$root.openLoading();

      let res;
      if (window.localStorage.getItem("token") === null) {
        res = await this.$helloHttp(
          `/activitys/${this.$route.params.id}`,
          {},
          "get"
        )
      } else {
        res = await this.$helloHttp(
          `/activitys/${this.$route.params.id}`,
          {},
          "get",
          {
            Authorization: `Bearer ${window.localStorage.getItem("token")}`
          }
        )
      }

      this.activity = res.data;
      this.$root.closeLoading();
    }
  },
  mounted() {
    if (window.localStorage.getItem("token")) {
      this.mid = window.localStorage.getItem("mid");
      this.getActivity();
    } else if (this.$route.query.code) {
      this.applyAuth();
    } else {
      // 当使用localhost域名调试的时候，先访问pre-www.hellobuluo.com/activity-1.html从localstorage里面获取token
      // 在访问localhost，将token值set进去
      if (!window.location.href.includes("localhost")) {
        wxApi
          .init({
            appid: process.env.VUE_APP_APP_ID, // 正式测试号
            redirectUri: window.location.href
          })
          .author(true);
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/constant.scss";
.activity-container {
  .activity-inner-container {
    display: flex;
    flex-direction: column;
    padding: 0.53333rem;
  }
  .title-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .share-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #ff3e90;
    border-radius: 20px;
    width: 100px;
    color: #ff3e90;
  }
  .cover {
    height: 350px;
    width: 100%;
    border-radius: 10px;
    object-fit: cover;
  }
  .item-container {
    display: flex;
    align-items: flex-start;
  }
  .item-icon {
    margin: 20px 20px 0 0;
  }
  .item-right {
    display: flex;
    flex-direction: column;
  }
  .item-title {
    font-size: 28px;
    font-weight: bold;
    margin: 20px 0;
  }
  .item-content {
    font-size: 28px;
    color: rgba(0, 0, 0, 0.4);
  }
  .apply-btn,
  .reapply-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 30px;
    color: #fff;
    line-height: 50px;
    background: #ff3e90;
    position: fixed;
    bottom: 0;
    font-size: 28px;
    font-weight: bold;
  }
  .apply-cancel-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 30px 50px;
    color: black;
    line-height: 50px;
    background: rgba(0, 0, 0, 0.05);
    position: fixed;
    bottom: 0;
    font-weight: bold;
  }
  .apply-success-text {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.3);
  }
  .apply-cancel-text {
    font-size: 28px;
  }
  .reapply-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 30px;
    color: #ff3e90;
    line-height: 50px;
    background: white;
    position: fixed;
    bottom: 0;
    font-size: 28px;
    font-weight: bold;
  }
  .mid-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
  }
  .popup-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px;
  }
}
</style>
